import { ShieldAlert, AlertTriangle, DollarSign, Mail } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const PhishingHeroSection = () => {
  return (
    <section className="pt-24 pb-8 sm:pt-28 sm:pb-10">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <Badge variant="outline" className="text-destructive border-destructive/30 bg-destructive/5">
          <ShieldAlert className="w-3 h-3 mr-1" />
          Cybersecurity
        </Badge>
        <Badge variant="outline" className="text-muted-foreground border-border">
          11 min read
        </Badge>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-foreground leading-tight mb-4">
        How to Identify and Prevent{" "}
        <span className="text-destructive">Phishing Attacks</span>
      </h1>

      <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-3xl mb-8">
        Learn to recognize phishing emails, understand attack vectors, and implement security measures 
        that protect your team from credential theft and data breaches.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Mail className="w-6 h-6 text-destructive mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">91%</div>
          <div className="text-sm text-muted-foreground">Attacks via email</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <DollarSign className="w-6 h-6 text-chart-2 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">$4.76M</div>
          <div className="text-sm text-muted-foreground">Avg breach cost</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <AlertTriangle className="w-6 h-6 text-chart-1 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">3.4B</div>
          <div className="text-sm text-muted-foreground">Daily phishing emails</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <ShieldAlert className="w-6 h-6 text-primary mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">36%</div>
          <div className="text-sm text-muted-foreground">Breaches from phishing</div>
        </div>
      </div>
    </section>
  );
};
